import { render, staticRenderFns } from "./amount-details.vue?vue&type=template&id=55978228&"
import script from "./amount-details.vue?vue&type=script&lang=js&"
export * from "./amount-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports